import React from "react";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const SubscriptionPopup = ({ isVisible, type, onClose }) => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();

  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      dir={direction}
    >
      <div className="max-w-sm p-8 mx-4 text-center bg-white rounded-lg shadow-lg">
        <div className="mb-4">
          {type === "success" ? (
            <div className="flex items-center justify-center w-16 h-16 mx-auto bg-green-500 rounded-full">
              <CheckIcon className="w-8 h-8 text-white" />
            </div>
          ) : (
            <div className="flex items-center justify-center w-16 h-16 mx-auto bg-red-500 rounded-full">
              <XMarkIcon className="w-8 h-8 text-white" />
            </div>
          )}
        </div>

        <h2 className="mb-2 text-xl font-semibold text-gray-800">
          {type === "success"
            ? t("subscriptionConfirmed")
            : t("subscriptionError")}
        </h2>

        <p className="text-sm text-gray-600">
          {type === "success"
            ? t("subscriptionSuccessMessage")
            : t("subscriptionErrorMessage")}
        </p>
      </div>
    </div>
  );
};

export default SubscriptionPopup;
